import { aiReceptionistReducer } from "./aiReceptionistReducer";
import { aiReceptionistReportReducer } from "./aiReceptionistReportReducer";

const aiReceptionistReducers = {
  aiReceptionist: aiReceptionistReducer,
  aiReceptionistReport: aiReceptionistReportReducer,
};

export default aiReceptionistReducers;